var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 864,
    height: 863,
    viewBox: "0 0 864 863",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 215.5C0 96.4826 96.4826 0 215.5 0V0C334.517 0 431 96.7323 431 215.75V215.75C431 335.043 334.294 432 215 432H0L0 215.5Z",
    fill: "#1CC8EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.5 646C431.5 526.983 527.983 430.5 647 430.5V430.5C766.017 430.5 862.5 527.232 862.5 646.25V646.25C862.5 765.543 765.794 862.5 646.5 862.5H431.5V646Z",
    fill: "#1CC8EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M431.5 216.5C431.5 97.2065 528.457 0.5 647.75 0.5V0.5C766.768 0.5 863.5 96.9826 863.5 216V216C863.5 335.017 767.017 431.5 648 431.5H431.5V216.5Z",
    fill: "#5F2EEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 647C0.5 527.983 96.9826 431.5 216 431.5H431.5V647C431.5 766.017 335.017 862.5 216 862.5V862.5C96.9826 862.5 0.5 766.017 0.5 647V647Z",
    fill: "#5F2EEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoR);
export default __webpack_public_path__ + "static/media/LogoR.821ea2a98ac3710847d22b57231ac8fc.svg";
export { ForwardRef as ReactComponent };